import {DateTime} from 'luxon';
import {weekCalendarEvents} from '../overview/overviewWeek';

export const CALENDAR_DISPLAYS=[['list','List View'],['detailed','Detailed'],['month','Month Grid View']];

export function calendarDisplayDays(date,zone,display) {
  const day=DateTime.fromObject({year:date.getFullYear(),month:date.getMonth()+1,day:date.getDate()},{zone});
  const start=display==='month'?day.startOf('month').startOf('week'):day.startOf('week');
  const end=display==='month'?day.endOf('month').endOf('week'):start.plus({days:6});
  const count=Math.round(end.startOf('day').diff(start,'days').days)+1;
  return Array.from({length:count},(_,index)=>start.plus({days:index}));
}

export function calendarDisplayEvents(events,days) {
  // The shared recurrence engine handles moved instances, exceptions and
  // overnight occurrences, including those beginning before the visible range.
  return weekCalendarEvents(events,days);
}

export function isEventParticipant(event,uid,username) {
  if(!uid)return false;
  if(event.calendar==='personal')return true;
  if(String(event.participantStates?.[uid]?.status).toLowerCase()==='declined')return false;
  const ids=Array.isArray(event.participantsUid)?event.participantsUid:[];
  const people=Array.isArray(event.participants)?event.participants:[];
  if(ids.includes(uid)||people.some(person=>person&&typeof person==='object'&&person.uid===uid))return true;
  // Only older events without participant IDs fall back to the account name.
  return !ids.length&&!!username&&people.some(person=>typeof person==='string'&&person.trim().toLowerCase()===username.trim().toLowerCase());
}
